
import React from 'react';
import { TableHeader, TableRow, TableHead } from '@/components/ui/table';

interface TransportationTableHeaderProps {
  showEditColumn?: boolean;
}

export const TransportationTableHeader: React.FC<TransportationTableHeaderProps> = ({
  showEditColumn = false
}) => {
  return (
    <TableHeader>
      <TableRow>
        <TableHead>Date</TableHead>
        <TableHead>Time</TableHead>
        <TableHead>Transportation</TableHead>
        <TableHead>Route</TableHead>
        <TableHead>Traveler</TableHead>
        <TableHead className="hidden md:table-cell">Confirmation</TableHead>
        <TableHead className="hidden md:table-cell">Notes</TableHead>
        {showEditColumn && <TableHead className="w-[50px]">Edit</TableHead>}
      </TableRow>
    </TableHeader>
  );
};
